const initialState = {
  isLoading: false,
  isPage: "",
  isExpired: null,
  hydrated: false,
  fileTypes:[],
};
const spinnerReducer = (state, action) => {
  if (!state || !state.hydrated) {
    state = {
      ...initialState,
      ...state,
      hydrated: true,
    };
  }
  if (action.type === "SET_SPINNER") {
    return {
      ...state,
      isLoading: action.payload,
    };
  } else if (action.type === "SET_PAGE_NAME") {
    return {
      ...state,
      isPage: action.payload,
    };
  } else if (action.type === "SESSION_EXPIRED") {
    console.log("exp-", action.payload);
    return {
      ...state,
      isExpired: action.payload,
    };
  } else if(action.type === "GET_FILE_ATTACHMENT_TYPES"){
    return {
      ...state,
      fileTypes:action.payload?.data??[],
    }
  }
  else {
    return state;
  }
};
export default spinnerReducer;
